export default __webpack_public_path__ + "static/media/Banner-cic-1-agenda.db9061f0.jpg";